/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Team from '../model/Team';
import APIEndPoints from "./ApiEndpoints";

/**
* CardsController service.
* @module api/TeamControllerApi
* @version 1.0
*/
export default class TeamControllerApi {

    /**
    * Constructs a new TeamControllerApi. 
    * @alias module:api/TeamControllerApi
    * @class
    * @param {module:ApiClient} [apiTeam] Optional API team implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiTeam) {
        this.apiTeam = apiTeam || ApiClient.instance;
        this.endPoints = new APIEndPoints();
    }




    /**
     * getTeam
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Team>} and HTTP response
     */
    getTeamsUsingGETWithHttpInfo() {
        let postBody = null;

        let pathParams = {
        };
        let queryParams = {
        };
        let headerParams = {
        };
        let formParams = {
        };

        let authNames = ["password_grant"];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = [Team];
        return this.apiTeam.callApi(
            this.endPoints.team.GetAll.URI,
            this.endPoints.team.GetAll.Type,
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, null
        );
    }

    /**
     * getTeam
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Team>}
     */
    getTeamsUsingGET() {
        return this.getTeamsUsingGETWithHttpInfo()
            .then(function (response_and_data) {
                return response_and_data.data;
            });
    }


    /**
     * getAddTeam
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Team>} and HTTP response
     */
    addTeamWithHttpInfo(body) {
        let postBody = body;

        let pathParams = {
        };
        let queryParams = {
        };
        let headerParams = {
        };
        let formParams = {
        };

        let authNames = ["password_grant"];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = Team;
        return this.apiTeam.callApi(
            this.endPoints.team.Post.URI,
            this.endPoints.team.Post.Type,
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, null
        );
    }

    /**
     * getAddTeam
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Team>}
     */
    addTeam(body) {
        return this.addTeamWithHttpInfo(body)
            .then(function (response_and_data) {
                return response_and_data.data;
            });
    }


    /**
 * getTeam
 * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Team>} and HTTP response
 */
    removeTeamWithHttpInfo(id) {
        let postBody = null;

        let pathParams = {
            id: id
        };
        let queryParams = {
        };
        let headerParams = {
        };
        let formParams = {
        };

        let authNames = ["password_grant"];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = Team;
        return this.apiTeam.callApi(
            this.endPoints.team.Delete.URI,
            this.endPoints.team.Delete.Type,
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, null
        );
    }

    /**
     * getTeam
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Team>}
     */
    removeTeam(id) {
        return this.removeTeamWithHttpInfo(id)
            .then(function (response_and_data) {
                return response_and_data.data;
            });
    }


    getTeamByIdUsingPOST(body) {
        return this.getTeamByIdUsingPOSTWithHttpInfo(body).then(function (
            response_and_data
        ) {
            return response_and_data.data;
        });
    }

    getTeamByIdUsingPOSTWithHttpInfo(body) {

        let postBody = body;

        let pathParams = {
            id: body.Id
        };
        let queryParams = {
        };
        let headerParams = {};
        let formParams = {};

        let authNames = ["password_grant"];
        let contentTypes = [];
        let accepts = ["*/*"];
        let returnType = Team;
        return this.apiTeam.callApi(
            this.endPoints.team.GetById.URI + '/' + body.Id,
            this.endPoints.team.GetById.Type,
            pathParams,
            queryParams,
            headerParams,
            formParams,
            postBody,
            authNames,
            contentTypes,
            accepts,
            returnType,
            null
        );
    }


}
